import React from "react"
import { TRACE_MENU_LABEL } from "./useChartTraceMenu"

/**
 * The number of a KPI or scorecard tile: a button that opens its trace on
 * a click, Enter or Space, or plain text when `onTrace` is not given.
 */
const TraceValue: React.FC<{ text: string; onTrace?: () => void }> = ({
  text,
  onTrace,
}) =>
  onTrace ? (
    <button
      type="button"
      className="dq-trace-value"
      title={TRACE_MENU_LABEL}
      onClick={onTrace}
    >
      {text}
    </button>
  ) : (
    <>{text}</>
  )

export default TraceValue
